
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.3","height":"18.3"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 1095","transform":"translate(-6058.35 843.65)"}},[_c('circle',{attrs:{"data-name":"Elipse 100","cx":"8.5","cy":"8.5","r":"8.5","transform":"translate(6059 -843)","fill":"#f1f1f1","stroke":"#0f587f","stroke-width":"1.3"}}),_c('path',{attrs:{"data-name":"Trazado 205","d":"M6066.771-830.213v-6.133h1.447v6.133zm.729-7a.834.834 0 01-.591-.231.734.734 0 01-.246-.555.733.733 0 01.247-.555.834.834 0 01.59-.231.833.833 0 01.591.231.735.735 0 01.246.555.735.735 0 01-.246.555.832.832 0 01-.59.229z","fill":"#0f587f"}})])])
          )
        }
      }
    